import { z } from 'zod';
export const sharepointSettingsTenantSchema = z
    .object({
    tenantId: z.string().min(1, 'Tenant ID is required'),
    tenantName: z.string().min(1, 'Tenant name is required'),
})
    .partial();
export const sharepointSettingsSiteSchema = z.object({
    siteId: z.string().min(1, 'Site ID is required'),
    siteName: z.string().min(1, 'Site name is required'),
});
